import React, {Dispatch, useEffect, useState} from 'react';
import { getIconUrl } from "./helpers";
import './Introduce.scss'

type Props = {
    setShowIntroduce: Dispatch<boolean>
}
function Introduce({ setShowIntroduce }: Props) {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return <div className={'IntroduceStep'}>
        <div className="container">
            <div className="row">
                <center><h2>DOBÓR ZBIORNIKA NA DESZCZÓWKĘ W MNIEJ NIŻ MINUTĘ!</h2></center>
            </div>
            <div className="row">
                <div className="col-md-4">
                    <div className="iconContainer">
                        <img className="iconTop" src={getIconUrl('map.svg')} />
                        <img className="iconBottom" src={getIconUrl('arrow-yellow-v2.svg')} />
                        <div>
                            <center><h2>KROK 1</h2></center>
                            <center><h3>ZNAJDŹ SWOJĄ MIEJSCOWOŚĆ</h3></center>
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="iconContainer">
                        <img className="iconTop" src={getIconUrl('building.svg')} />
                        <img className="iconBottom" src={getIconUrl('arrow-green-v2.svg')} />
                        <div>
                            <center><h2>KROK 2</h2></center>
                            <center><h3>PODAJ INFORMACJE O BUDYNKU</h3></center>
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="iconContainer">
                        <img className="iconTop" src={getIconUrl('report.svg')} />
                        <img className="iconBottom" src={getIconUrl('arrow-blue-v2.svg')} />
                        <div>
                            <center><h2>KROK 3</h2></center>
                            <center><h3>RAPORT I DOBÓR ROZWIĄZANIA</h3></center>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <div className="buttonContainer">
                        <a className="yellow-button" onClick={() => setShowIntroduce(false)}>Rozpocznij</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
}

export default Introduce;